import React, { FC } from 'react';
import { Grid, TableCell, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { find } from 'lodash';

import { Network, SharesItem } from 'api';
import { SocialAccountIcon } from 'components';
import { useSocialConnections } from 'hooks';
import { isUrl } from 'features/content/helpers';
import { getSocialAccountName } from 'helpers';

import UrlMetadata from '../UrlMetadata';
import Body from '../Body';

interface IProps {
  item: SharesItem;
}

const useStyles = makeStyles(theme => ({
  cell: {
    paddingTop: theme.spacing(1),
  },
  network: {
    display: 'inline-flex',
    marginRight: theme.spacing(2),
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
  content: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
}));

const PastShareCell: FC<IProps> = ({ item }) => {
  const classes = useStyles();
  const connections = useSocialConnections();
  const { content } = item;

  if (!content) {
    return <TableCell align="left" classes={{ body: classes.cell }} />;
  }

  function getSocialAccount() {
    const { network_id } = item;
    const account = find(connections, ['id', network_id]);

    return getSocialAccountName(account);
  }

  function renderNetwork() {
    return (
      <Grid container className={classes.network}>
        <Grid item>
          <SocialAccountIcon
            active
            provider={item.network as Network}
            size={16}
            className={classes.icon}
          />
        </Grid>
        <Grid item>
          <Typography color="textPrimary">{getSocialAccount()}</Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <TableCell align="left" classes={{ body: classes.cell }}>
      {renderNetwork()}
      <Typography variant="body2" color="textPrimary">
        {item.user_commentary}
      </Typography>
      <div className={classes.content}>
        {isUrl(content) ? <UrlMetadata content={content} /> : <Body content={content} />}
      </div>
    </TableCell>
  );
};

export default PastShareCell;
